module.exports = __webpack_public_path__ + "img/44_8.49c36991.png";